const userFieldsToShow: Array<string> = [
  'FaceMainConcern',
  'HairMainConcern',
  'knownLanguages',
  'communicationLanguagePreference',
  'latestAiDetection',
];

const consultationFieldsToSkip: Array<string> = [
  'ACL',
  'objectId',
  'username',
  'user',
  'createdAt',
  'updatedAt',
  'archive',
  'PrivateTreeCompleted',
  'PrivateMainConcernClass',
  'TakeInstantCheckSideFace',
  'PrivateRegimenGivenPointer',
  'PrivateInstantCheckupDebug',
  'TakeInstantCheckup',
  'disableChat',
  'HairfallPhotoTop',
  'hairPhotos',
  'TakePhotoOrNot',
  'BodyPhoto',
  'HairfallPhoto',
  'facePhotos',
  'concernList',
  'attended',
  'dbArchive',
  'configSecondaryConcern',
  'configPrimaryConcern',
  'configPrimaryConcernSeverity',
  'treePaths',
  'mainConcernLLMResponse',
];

const temporaryAnswerFieldsToSkip: Array<string> = [
  'ACL',
  'updatedAt',
  'expireOn',
  'user',
  'objectId',
  'dbArchive',
];

export { userFieldsToShow, consultationFieldsToSkip, temporaryAnswerFieldsToSkip };
